'use strict';
import { ApiRequest } from '../../../../../../../common/api/request';

export class AtruviaUserDataModalService extends ApiRequest {
  constructor(appConfig, $q, $http, uiModalDeclarationService) {
    'ngInject';
    super({
      appConfig,
      $q,
      $http,
      uiModalDeclarationService,
    });
  }

  fetchPersonendaten(iban) {
    return this.$http.post(
      `${this.api}/atruvia/personendaten/person`,
      {
        iban,
      },
      {
        error: {
          silent: true,
        },
      },
    );
  }

  fetchAddresses(person) {
    return this.$http.post(
      `${this.api}/atruvia/personendaten/addresses`,
      person,
    );
  }

  stashUser(persons) {
    return this.$http.post(`${this.api}/atruvia/personendaten/stash`, persons);
  }

  openModal(userData) {
    this.modal = this.uiModalDeclarationService.$uibModal.open({
      component: 'atruviaUserDataModalComponent',
      windowTopClass: 'atruvia-user-data-modal',
      backdrop: 'static',
      resolve: {
        userData: () => userData,
      },
    });

    return this.modal;
  }

  closeModal(userData) {
    if (this.modal) {
      userData ? this.modal.close(userData) : this.modal.dismiss();
    }
  }
}
